import { ActionType } from "typesafe-actions";

import { Platform } from "../common_types";

import * as actions from "./actions";

export type HostsAction = ActionType<typeof actions>;

export interface HostBase {
  searches: number;
  clicks: number;
  bc: number;
  cbc: number;
  pbc: number;
  ctr: number;
  btr: number;
  str: number;
  productivity: number;
}

export interface HostItem extends HostBase {
  platform: Platform;
  date: string;
}

export type HostsMetric = "searches" | "clicks" | "ctr" | "pbc" | "str";

export interface HostChartItem {
  date: string;
  web: number;
  android: number;
  iphone: number;
  ipad: number;
  mobile: number;
  other: number;
}

export interface HostsState {
  count: number;
  dataIsLoading: boolean;
  chartDataIsLoading: boolean;
  items: HostItem[];
  chartItems: HostChartItem[];
  summary?: HostBase;
  summaryIsLoading: boolean;
}

export enum HostsActionTypes {
  DATA_FETCH_REQUEST = "@Hosts/DATA_FETCH_REQUEST",
  DATA_FETCH_SUCCESS = "@Hosts/DATA_FETCH_SUCCESS",
  DATA_FETCH_ERROR = "@Hosts/DATA_FETCH_ERROR",

  SUMMARY_FETCH_REQUEST = "@Hosts/SUMMARY_FETCH_REQUEST",
  SUMMARY_FETCH_SUCCESS = "@Hosts/SUMMARY_FETCH_SUCCESS",
  SUMMARY_FETCH_ERROR = "@Hosts/SUMMARY_FETCH_ERROR",

  CHART_DATA_FETCH_REQUEST = "@Hosts/CHART_DATA_FETCH_REQUEST",
  CHART_DATA_FETCH_SUCCESS = "@Hosts/CHART_DATA_FETCH_SUCCESS",
  CHART_DATA_FETCH_ERROR = "@Hosts/CHART_DATA_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Hosts/GENERATE_REPORT_REQUEST",
}

export interface HostsPayload {
  platform?: Platform[];
}

export interface HostsChartPayload {
  metric: HostsMetric;
}
